/* RESPONSIBLE TEAM: team-fin-voice */
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/-private/transition';
import type IntlService from 'embercom/services/intl';

const OPERATOR_SETTINGS_PERMISSION = 'can_create_and_edit_bots';

export default class FinAIAgentSettingsPronunciationsRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare permissionsService: any;
  @service declare intl: IntlService;

  analytics = {
    section: 'ai-chatbot',
    place: 'settings.pronunciations',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.voice-playground.pronunciations-title');
  }

  beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      OPERATOR_SETTINGS_PERMISSION,
      transition,
    );
  }

  get app() {
    return this.appService.app;
  }
}
